<template>
  <div id="ReviewForm">
    <GoogleFormWrapper :formSrc="formSrc" :isAlwaysScrollable="true" />
  </div>
</template>

<script>
import GoogleFormWrapper from 'views/components/GoogleFormWrap'

export default {
  components: { GoogleFormWrapper },
  data() {
    return {
      formSrc: 'https://docs.google.com/forms/d/e/1FAIpQLSdKWUWOxthfEKhqfB9C8I3rNrd3RWWVnTNISjd-WdDZg38-3Q/viewform?embedded=true',
    }
  },
}
</script>

<style lang="scss">
#ReviewForm {
  background-color: $white;

  .GoogleFormWrapper {
    iframe {
      border: none;
      height: 96vh;
      width: 100%;
    }
  }
}
</style>
